"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function InterFaceSvg(props) {
  var enterUrl = props.enterUrl,
    leaveUrl = props.leaveUrl,
    className = props.className,
    style = props.style;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("inter-face-svg " + (className || '')),
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "v3-doc-anchor-list-link-img is-leave",
    style: {
      backgroundImage: "url(" + leaveUrl + ")"
    }
  }), /*#__PURE__*/_react["default"].createElement("i", {
    className: "v3-doc-anchor-list-link-img-hover is-enter",
    style: {
      backgroundImage: "url(" + enterUrl + ")"
    }
  }));
}
var _default = exports["default"] = InterFaceSvg;